<template>

  <VaDropdown :autoPlacement="true" v-model="dropdwon">
    <template #anchor>
      <VaButton class="mr-2" preset="plain" text-color="#242424">
        {{ locale.toUpperCase() }}
        
        <div style="width: 12px; margin-left: 4px;">
          <va-icon v-if="!dropdwon" name="expand_more"></va-icon>
          <va-icon v-if="dropdwon" name="expand_less"></va-icon>
        </div>
      </VaButton>
    </template>

    <VaDropdownContent class="lang-switch-content"> 
      <va-button preset="plain" text-color="#242424" @click="switchLanguage('en')" :style="locale == 'en' ? `background: #eee; padding: 6px 12px` : 'padding: 6px 12px' ">
        EN
        <div style="width: 12px; margin-left: 4px;">
          <va-icon v-if="locale == 'en'" name="check"></va-icon>
        </div>
      </va-button>
      <va-button preset="plain" text-color="#242424" @click="switchLanguage('de')" :style="locale == 'de' ? `background: #eee; padding: 6px 12px` : 'padding: 6px 12px' ">
        DE
        <div style="width: 12px; margin-left: 4px;">
          <va-icon v-if="locale == 'de'" name="check"></va-icon>
        </div>
      </va-button>
    </VaDropdownContent>
  </VaDropdown>

  <!--
  <va-select
    class="mr-1 lang"

    target="body"
    :prevent-overflow="true"

    :options="options"
    :text-by="(item) => item.text.toUpperCase()"
    track-by="code"

    v-model="lang_select"
    color="#54565a"
    @update:model-value="switchLanguage(lang_select)"
  >
  </va-select>
  -->
</template>

<script>
import { useGlobalConfig } from 'vuestic-ui'


import { useI18n } from 'vue-i18n'
  import { useRouter } from "vue-router"
  import Tr from "@/i18n/translation"

export default {
  name: 'LangSwitcher',

  setup() {
    const { t, locale } = useI18n()

    const supportedLocales = Tr.supportedLocales

    const router = useRouter()

    const switchLanguage = async (event) => {
      const newLocale = event

      await Tr.switchLanguage(newLocale)

      try {
        await router.replace({ params: { locale: newLocale } })
      } catch(e) {
        console.log(e)
        router.push("/")
      }
    }

    return { t, locale, supportedLocales, switchLanguage }
  },

  data () {
    const options =  [
      {
        code: 'en',
        text: 'EN',
        name: 'english',
      },
      {
        code: 'de',
        text: 'DE ',
        name: 'deutsch',
      },
    ]

    const lang_select = options.filter((item) => {return item.code == this.$i18n.locale}).length >= 1 ? options.filter((item) => {return item.code == this.$i18n.locale})[0] : options[0];

    return {
      lang_select: lang_select,
      options: options,

      dropdwon: false
    }
  },

  props: { },

  methods: {
    setLanguage (locale) {
      // this.$i18n.locale = locale.code;
      // localStorage.setItem('locale', this.$i18n.locale)

      localStorage.setItem('locale', locale.code)

      /*
      this.$router.push({ name: this.$route.name, params: { locale: this.$i18n.locale }})

      setTimeout(() => {
        this.$router.go()
      }, 100)
      */

      let _href = window.location.href

      let _url  = _href.split('?')[0]
      if(!_url.endsWith('/')) {
        _url += '/';
      }

      let _query = _href.split('?')[1]

      _href = _url.replace('/en/', '/<lang>/')
      _href = _href.replace('/de/', '/<lang>/')

      _href = _href.replace('<lang>', locale.code)

      if(_query) {
        _href += '?' + _query;
      }

      window.location.href = _href;
    },

    currentLanguage () {
      return this.$i18n.locale === 'en' ? 'en' : this.$i18n.locale
    },
  },
}
</script>

<style lang="scss">
// @import "~flag-icon-css/css/flag-icon.css";

.lang {
  width: 80px;

  .va-input-wrapper__field:after {
    opacity: 0;
  }

  .va-input-wrapper__field {
    border: none;
  }

  .va-input-wrapper__text {
    width: auto;
    width: 24px;
    margin-right: 2px;
    font-family: 'Lato-Bold';
  }

  .va-input-wrapper__append-inner {
    margin-top: -2px;
  }
}

.lang-switch-content {
  z-index: 999 !important;
  display: flex;
  flex-direction: column;
  min-width: unset !important;
  padding: 4px;
}
</style>
